var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('PasswordConfirm',{attrs:{"pwdConfirm":_vm.pwdConfirm},on:{"confirmPwd":_vm.fnConfirmPwd,"confirmCancel":_vm.fnConfirmCancel}}),_c('ConfirmMemInfo',{ref:"memInfo",attrs:{"memberInfo":_vm.memberInfo},on:{"memInfoCancel":_vm.fnMemInfoCancel,"confirmMove":_vm.fnAmhoConfirmMove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }